/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import clsx from "clsx";
import {PackageItem} from "types/entities/PackageItem";
import {translate} from "utils/utility";
import {useTranslation} from "react-i18next";
import {PackageUpsellItemPrice} from "pages/Front/Booking/components/PackageUpsell/components/PackageUpsellItemPrice";

interface PackageCategoryDetailUpsellProps {
    className?: string;
    packageItem: PackageItem;
}

const PackageCategoryDetailUpsell = (props: PackageCategoryDetailUpsellProps) => {
    const {t} = useTranslation();

    // GroupInfo basis-1/2 flex flex-col items-center p-4 rounded-2xl bg-white shadow-lg

    return (
        <article className={clsx("PackageCategoryDetailUpsell flex flex-col w-full bg-white rounded-2xl shadow-lg", props.className)}>
            {props.packageItem.image && (
                <div className={"packageItemImage flex flex-col"}>
                    <img
                        className={"w-full h-full object-cover rounded-t-2xl max-h-[120px] sm:max-h-[150px] md:max-h-[180px] lg:max-h-[192px] xl:max-h-[250px]"}
                        src={props.packageItem.image}
                    />
                </div>
            )}

            <div className={"flex flex-col p-4 font-medium justify-between grow"}>
                <div>
                    <h4 className={"font-bold text-lg md:text-xl mb-4"}>{translate(props.packageItem.name)}</h4>
                    <h5 className={"font-regular italic text-base mb-4"}>{translate(props.packageItem.description)}</h5>
                </div>
                <PackageUpsellItemPrice packageItem={props.packageItem} />
            </div>
        </article>
    );
};

export default PackageCategoryDetailUpsell;
